import { render, staticRenderFns } from "./hr-selector.vue?vue&type=template&id=03b0c1f2&scoped=true"
import script from "./hr-selector.vue?vue&type=script&lang=js"
export * from "./hr-selector.vue?vue&type=script&lang=js"
import style0 from "./hr-selector.vue?vue&type=style&index=0&id=03b0c1f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0c1f2",
  null
  
)

export default component.exports